import { render } from "./SavingsForMinors.vue?vue&type=template&id=52d0b534"
import script from "./SavingsForMinors.vue?vue&type=script&lang=js"
export * from "./SavingsForMinors.vue?vue&type=script&lang=js"

import "./SavingsForMinors.vue?vue&type=style&index=0&id=52d0b534&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__